// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yF63","question":"styles_question__28cIe","description":"styles_description__5NPmM"};